import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SingleResponseModel } from '../../models/base/base';
import { Observable, Subject, takeUntil } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ApiSessionService {
  baseUrl = environment.baseUrlHR + this.getResourceUrl();

  constructor(private http: HttpClient) { }

  getResourceUrl(): string {
    return 'Session';
  }

  private changeCurrentBranch(branchid: string): Observable<SingleResponseModel<any>> {
    return this.http.get<SingleResponseModel<any>>(`${this.baseUrl}/ChangeCurrentBranch?branchid=${branchid}`);
  }

  private changeCurrentPaySlip(payslipid: string): Observable<SingleResponseModel<any>> {
    return this.http.get<SingleResponseModel<any>>(`${this.baseUrl}/ChangeCurrentPaySlip?payslipid=${payslipid}`);
  }

  changeUserCurrentBranch(branchid: string): void {
    this.changeCurrentBranch(branchid).subscribe({
      next: () => { },
      error: (err) => {
      }
    })
  }

  changeUserCurrentPaySlip(payslipid): void {
    this.changeCurrentPaySlip(payslipid).subscribe({
      next: () => { },
      error: (err) => {
      }
    })
  }


}
